module.exports = __webpack_public_path__ + "img/quest_icon_0065_luck.28fece9a.png";